export enum AdminPharmacistsTableColumnTitle {
  FirstName = "Ime",
  LastName = "Prezime",
  Email = "Email",
  Active = "Aktivan",
  Options = "",
}
